package org.multiplatform.kotfolio.pages.flutter

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("/flutter/bloc")
@Composable
fun BLoCPage() {
    BlogLayout(
        PageProperties(
            "BLoC",
            "BLoC (Business Logic Component) is a popular architectural pattern in the Flutter. A family of stream/observable-based patterns."
        ),
        BlogProperties("Flutter", "BLoC / Cubit State Management")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "BLoC (Business Logic Component) is a popular architectural pattern in the Flutter community for building scalable and maintainable apps.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A family of stream/observable-based patterns.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "This architecture was developed by Google developers Paolo Soares and Cong Hui and it was announced for the first time at 2018 Dart Conference.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "BLoC takes input and output. Input is a stream of events. Output transforms the stream of state.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "BLoC is essentially a class that keeps the state of our app/feature/screen/widget, mutates it upon receiving input events, and notifying its change.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "In this pattern, the UI communicates with a BLoC, which handles all the business logic and state management. The BLoC then emits streams of data, which the UI can listen to and update the UI accordingly.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It can be modified and accessed by the widgets.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "BehaviourSubject is a special stream controller that gives us synchronous access to the last value of the stream. BehaviourSubject to keep track of the loading state, and update it as needed.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Use super() to override the initial state.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "returns the values and also terminates the function, where a yield, returns the value but does not terminate the function.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "BLoC separates the business logic from the UI by using streams, ensuring data flows in a single direction. UI events trigger changes in the BLoC, which then outputs new states via streams that the UI subscribes to. To use BLoC, you create a class that transforms incoming events into outgoing states. Flutter widgets listen to these streams and rebuild when new data arrives. BLoC enforces a clear and well-defined architectural pattern, scales effectively for complex applications, and is easy to test since the logic is written in pure Dart, independent of the UI.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "Key Features of Bloc",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Unidirectional Data Flow: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "Bloc enforces a strict one-way data flow from the UI to the business logic and back to the UI, ensuring an organized structure.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Reactive Programming: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "Utilizing Dart’s Stream API, Bloc handles asynchronous data effectively.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Strong Typing: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "Bloc is strongly typed, providing compile-time safety and reducing the risk of runtime errors.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "Advantages",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Predictable State Management: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "Built on the BLoC (Business Logic Component) pattern, it encourages a unidirectional data flow, which enhances predictability and maintainability.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Separation of Concerns: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "Encourages a clear separation between the presentation and business logic, facilitating easier testing and maintenance.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Scalability: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "Well-suited for large applications where you need a robust solution for managing complex state.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Stream-based Architecture: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "Leverages Dart’s streams and StreamBuilder for state management, offering fine-grained control over the state and its changes.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "Why choose BLoC?",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "BLoC (Business Logic Component) brings structure and clarity to Flutter apps. It separates UI from logic, making the code reusable, testable, and easy to maintain.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "With BLoC, every interaction becomes an event, and every change becomes a state—it's like having a conversation with your app! Plus, the power of BlocBuilder and BlocListener ensures the UI reacts seamlessly to state changes.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "𝐖𝐡𝐲 𝐅𝐥𝐮𝐭𝐭𝐞𝐫 𝐁𝐋𝐨𝐂 𝐢𝐬 𝐋𝐨𝐯𝐞𝐝 𝐚𝐧𝐝 𝐏𝐨𝐩𝐮𝐥𝐚𝐫 𝐛𝐲 𝐭𝐡𝐞 𝐃𝐞𝐯𝐞𝐥𝐨𝐩𝐞𝐫𝐬?",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "𝗦𝗲𝗽𝗮𝗿𝗮𝘁𝗶𝗼𝗻 𝗼𝗳 𝗖𝗼𝗻𝗰𝗲𝗿𝗻𝘀: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "Flutter BLoC allows for the separation of business logic and UI. This means that developers can focus on implementing the business logic in the BLoC without worrying about the UI, and vice versa.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "𝗖𝗼𝗱𝗲 𝗥𝗲𝘂𝘀𝗮𝗯𝗶𝗹𝗶𝘁𝘆: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "With Flutter BLoC, developers can create reusable business logic components that can be used across different parts of the application. This reduces code duplication and makes it easier to maintain the application’s codebase.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "𝗣𝗿𝗲𝗱𝗶𝗰𝘁𝗮𝗯𝗹𝗲 𝗦𝘁𝗮𝘁𝗲 𝗠𝗮𝗻𝗮𝗴𝗲𝗺𝗲𝗻𝘁: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "Flutter BLoC provides a predictable way of managing the state of the application. The BLoC emits new states in response to events from the UI, making it easier to reason about the application’s behavior.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "𝗧𝗲𝘀𝘁𝗮𝗯𝗶𝗹𝗶𝘁𝘆: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "Flutter BLoC makes it easier to write unit tests for the business logic of the application. Since the BLoC is separate from the UI, it can be tested independently of the UI.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "𝗟𝗮𝗿𝗴𝗲 𝗮𝗻𝗱 𝗖𝗼𝗺𝗽𝗹𝗲𝘅 𝗔𝗽𝗽𝗹𝗶𝗰𝗮𝘁𝗶𝗼𝗻𝘀: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "Flutter BLoC is particularly well-suited for large and complex applications, as it provides a scalable architecture that can be extended as the application grows.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "flutter_bloc context (watch, read, select)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "context.watch(): ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "Using the watch extension method on context to get the value of our Cubit. The new ‘MultiBlocBuilder’. From the widget that was build within the context BuildContext. Start searching for the unique instance of Bloc(), provided above in the widget tree, then After it’s found, watch or ‘subscribe’ to it’s stream of emitted states and whenever a new state is emitted by BlocA.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "context.select(): ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "The much simpler BuildWhen",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "context.read(): ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "The new companion for BlocProvider.of(context).",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "BLoC Architecture",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                SpanText(
                    text = "The Bloc class: This is the main class for creating a BLoC. It handles all the business logic and state management.",
                    modifier = Modifier
                        .fontSize(FontSize.Medium)
                        .fontWeight(FontWeight.Bold)
                )

                Li(Modifier.padding(topBottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "Events and actions: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "Events are simple classes that indicate an event and you trigger them on a certain point like a button press or inside initState. Eg: calling GET API will have an event class FetchNotesEvent.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(topBottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "States: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "The state is part of the application’s state. It is the output of a Bloc. The state is the information that can be read synchronously when the widget is built and might change during the lifetime of the widget. When a state changes, UI components will get the notification, and based on the current state it can re-render itself. States are the reactions to these actions, and they change according to the event that a user initiates by interacting with the interface. In BLOC, we give Event as input to BLoC. Then we do the processing/business logic in the Bloc and provide State as output.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(topBottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "BLoC: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "This is a class that maps events to states. It converts events into states and is the processing element that receives information and responds accordingly. When the FetchNotesEvent is triggered we send the FetchNotesLoadingState to the UI. After the API call is finished we send FetchNotesSuccessState or FetchNotesErrorState based on whether the API call was a success or failure.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(topBottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "BlocBuilder: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "This widget listens to a stream of data emitted by a BLoC and rebuilds the UI when the data changes. BlocBuilder handles building a widget in response to new states .BlocBuilder is similar to other builder widgets(StatefulBuilder, StreamBuilder, Builder) you might have used. It gives you access to context and the state. Inside the builder callback, you can check the current state and display widgets accordingly. Signature for the `builder` function which takes the BuildContext and state and is responsible for returning a widget that is to be rendered. Remember that the first state is the one that was previously created in the initialState method. To avoid memory leaks, you shouldn’t create an instance of the Bloc class when creating a BlocBulider class. If you do, you won’t be able to close streams in the Bloc class. My advice is to create a Bloc instance in the initState method and close it with blocA.close() in the dispose method.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(topBottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "Transition: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "The change from one state to another is called transition. It holds the current state, event, and the next state.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(topBottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "state: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "Variable that we can see, has access to the states. In this case, the state is just an integer value that will get incremented. So we can directly display the state.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(topBottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "Sink: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "(Sending Values to a Stream): It captures user interactions (e.g., button clicks) from the UI and sends these interactions as values to a stream. (A Sink in BLoC is an input endpoint that allows data to be added to the stream. It is typically used to receive events or user input that triggers changes in the BLoC’s state)",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(topBottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "Stream: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "A stream is an asynchronous flow of data that the user interface (UI) and BLoC react to. This represents the application data. The stream is managed by the business logic and any changes in the stream trigger UI updates. If you are new to Streams just think of a pipe with water flowing through it. Here the pipe is the Stream and the water is the asynchronous data that flows through this stream.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(topBottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "mapEventToState: ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    SpanText(
                        text = "Compute the state when an action is dispatched. It is information read synchronously. Every bloc must also override the mapEventToState function. This is a generator function, which accepts event and returns a stream, that notifies of state change whatever is subscribed to it. In the Redux world, this is a reducer.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                KotlinCode(
                    code = $$"""
                        Center(
                            child: BlocBuilder<CounterBloc, int>(
                                builder: (context, state) {
                                    return Text(
                                        '$state',
                                        style: TextStyle(fontSize: 50.0),
                                    );
                                },
                            ),
                        ),
                    """.trimIndent()
                )
            }

            SpanText(
                text = "Bloc Work",
                modifier = Modifier.fontSize(FontSize.Large)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                SpanText(
                    text = "BLoC uses a state and event to manage actions. BLoC which converts a Stream of incoming Events into a Stream of outgoing States. to get the response to the user inputs.",
                    modifier = Modifier
                        .fontSize(FontSize.Medium)
                )

                Li(Modifier.padding(topBottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "Event Triggering",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Events are an application’s inputs (like button press to load images, text inputs).",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "User interactions or other events trigger the BLoC to process the event and update its internal state.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Anywhere, including a UI widget, can fire an event. external circumstances, such as adjustments to sensor readings or network connectivity.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(topBottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "State Transformation",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The central class responsible for managing state and business logic.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }

                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The BLoC processes events and transitions from one state to another. This transformation is based on the business logic encapsulated within the BLoC.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(topBottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "UI Rendering",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    Ul {
                        Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "The UI layer subscribes to the BLoC’s state changes. When the state changes, the UI is re-rendered accordingly, providing a responsive and dynamic user experience.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }

                Li(Modifier.padding(topBottom = 0.5.em).toAttrs()) {
                    SpanText(
                        text = "State",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .fontWeight(FontWeight.Bold)
                            .textAlign(TextAlign.Start)
                    )

                    Ul {
                        Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                            SpanText(
                                text = "Represent the various states of the application, which can be changed in response to the event received.",
                                modifier = Modifier
                                    .fontSize(FontSize.Medium)
                            )
                        }
                    }
                }
            }

            SpanText(
                text = "BlocProvider",
                modifier = Modifier.fontSize(FontSize.Large)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "By default, BlocProvider creates the bloc lazily. BlocProvider will provide a single instance of a BLoC can be provided to multiple widgets within a subtree.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It’s typically placed at the root of your widget tree to make the bloc accessible to all child widgets that need it.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "BlocProvider is a Flutter widget that provides a bloc to its children. It is typically used at the top of a widget tree to enable all widgets within a subtree to retrieve the bloc using BlocProvider.of<T>(context).",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "BlocProvider is responsible for creating the bloc, it will automatically handle disposing the bloc.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "BlocProvider can be used to provide an existing bloc to a new portion of the widget tree. This will be most commonly used when an existing block needs to be made available to a new route. In this case, BlocProvider will not automatically dispose of the bloc since it did not create it.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                KotlinCode(
                    code = """
                    BlocProvider(
                      lazy: true/false, 
                      create: (BuildContext context) => BlocA(), child: Widget())
                    );
                    """.trimIndent()
                )
            }

            SpanText(
                text = "restartable()",
                modifier = Modifier.fontSize(FontSize.Large)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Instead of letting every event handler run to completion, restartable cancels the previous async work when a new event of the same type arrives. In practice, it means: for things like search, filters, live queries, or fast-changing input, only the latest request is allowed to finish.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            //https://www.linkedin.com/in/ethiel-adiassa
            KotlinCode(
                code = """
                    on<SearchSubmitted>(
                        _onSearch,
                        transformer: restartable() //cancels previous search
                    )
                    
                    Future <void> _onSearch(
                        SearchSubmitted event,
                        Emitter‹SearchState> emit,
                    )
                    async {
                        emit(SearchLoading());
                        final result = await repo.search(event.query);
                        emit(SearchLoaded(result));
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "MultiBlocProvider",
                modifier = Modifier.fontSize(FontSize.Large)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Flutter widget that merges multiple BlocProvider widgets into one.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "MultiBlocProvider improves readability and eliminates the need to nest multiple BlocProviders.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "BlocProviderTree",
                modifier = Modifier.fontSize(FontSize.Large)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It is a Flutter widget that merges multiple BlocProvider widgets into one.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "BlocProviderTree improves the readability and eliminates the need to nest multiple BlocProviders.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                KotlinCode(
                    code = """
                    BlocProviderTree( blocProviders: [ 
                      BlocProvider(bloc: BlocA()), 
                      BlocProvider(bloc: BlocB()), 
                      BlocProvider(bloc: BlocC())], 
                    child: ChildA())
                    """.trimIndent()
                )
            }

            SpanText(
                text = "BLocObserver",
                modifier = Modifier.fontSize(FontSize.Large)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                SpanText(
                    text = "BlocObserver of bloc pattern to debug your app states and events. With this, you may keep track of your app states and events that are triggers. BlocObserver gives you a few methods like onEvent(), onTransition(), and onChange(). To be able to use you need to override them.",
                    modifier = Modifier.padding(topBottom = 0.3.em)
                        .fontSize(FontSize.Medium)
                )

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "onEvent() gets called when an event has been added in the EventHanlder.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "onTransition() gets called before updating the states and after onEvent() method.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "onChange() gets called after onEvent() and onTransition() method.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                SpanText(
                    text = "All these methods get called before updating any states. onTransition and onChange both consist of currentState and nextState. But onTransition also tells you which event could case the next state change. This is cool for debugging.",
                    modifier = Modifier.padding(bottom = 0.3.em)
                        .fontSize(FontSize.Medium)
                )
            }

            SpanText(
                text = "Bloc Create (Bloc Initialization)",
                modifier = Modifier.fontSize(FontSize.Large)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "This component refers to the initialization of your BLoC instances. In your application, you create instances of your BLoC classes to manage different parts of the application’s state and logic.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Typically, you create BLoC instances at the top level of your widget hierarchy, often within the main function or the build method of your app's root widget.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "BLoC Lazy Loading",
                modifier = Modifier.fontSize(FontSize.Large)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "There are times you want to load some blocs in a certain order and give priority.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Each BlocProvider has a property called lazy. The default value is true, this means that you load the bloc lazily. If you never mention lazy to false then all the blocs would be loaded lazily if you have MultiBlocProvider.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "And with default settings, it’s memory efficient. And certain bloc is loaded into the memory if you use or find the bloc using BlocProvider.of<BlocName>(context).stateName",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "You may also look up the blocs using context.read<BlocName>.stateName",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "If you set lazy to false, this certain bloc would be loaded into the memory immediately as soon as your app runs.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "If you set all your BlocProvider’s property lazy to false, all of them would be immediately loaded into the memory.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                KotlinCode(
                    code = """
                    MultiBlocProvider(
                          providers: [
                            BlocProvider(
                                lazy: false,
                                create: (context) => WelcomeBloc()
                            ),
                            BlocProvider(
                                lazy: false,
                                create: (context) => AppBlocs()
                            ),
                          ],
                        child:.....
                    )
                    """.trimIndent()
                )
            }

            SpanText(
                text = "BlocBuilder",
                modifier = Modifier.fontSize(FontSize.Large)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It is used to rebuild a part of the UI in response to changes in the state of a bloc.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The Bloc builder returns a widget based on the state. The state is built in a required builder function.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "With the help of the widget, the overall boilerplate code requirement gets reduced. Therefore, the tasks of building and rebuilding the child subtree during state changes become easy to perform.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It takes a Bloc and a builder function and automatically rebuilds the UI when the state of the bloc changes.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Re-Builds the UI FOR EVERY NEW STATE coming from the bloc.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "This builder function may be called MULTIPLE TIMES PER STATE (due to Flutter Engine)",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                KotlinCode(
                    code = """
                    BlocBuilder<BlocA, BlocAState>(
                      builder: (context, state) {
                        // do stuff here based on BlocA's state
                      }
                    )
                    """.trimIndent()
                )
            }

            SpanText(
                text = "BlocListener",
                modifier = Modifier.fontSize(FontSize.Large)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It is a Flutter widget that merges multiple BlocListener widgets into one.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The bloc listener widget is used as an observer. It requires a listener function and an optional child.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "BlocWidgetListener and invokes the listener method while getting the response to state changes in the bloc.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It does not build or rebuild UI, but can be used to react to state changes by calling functionalities such as toasts, alert dialogs, or just executing functions.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The listener function is called ONLY ONCE PER STATE can not INCLUDING THE INITIAL STATE such as navigation, showing a SnackBar, showing a Dialog, increasing or decreasing the value for the counter app, etc.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "If the bloc parameter is omitted, BlocListener will automatically perform a lookup using BlocProvider and the current BuildContext.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                KotlinCode(
                    code = """
                    BlocListener<BlocA, BlocAState>(
                      listener: (context, state) {
                        // do stuff here based on BlocA's state
                      },
                      child: Container(),
                    )
                    """.trimIndent()
                )
            }

            SpanText(
                text = "BlocBuilder Vs BlocListener",
                modifier = Modifier.fontSize(FontSize.Large)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "BlocBuilder: Rebuilding widgets this builder function may be called multiple times per state (due to the filter engine).",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "BlocListener: This listener function is called only once per state (not including the initial state).",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "MultiBlocListener",
                modifier = Modifier.fontSize(FontSize.Large)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Flutter widget that merges multiple BlocListener widgets into one. MultiBlocListener improves the readability and eliminates the need to nest multiple BlocListeners.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "BLoC Consumer",
                modifier = Modifier.fontSize(FontSize.Large)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "This Bloc widget is a combination of the listener and the builder. It uses a required listener and builder function to react to state changes. It is recommended that Bloc consumer be used only when you want to simultaneously rebuild your UI and perform other actions in response to state changes.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Bloc Consumer combines the functionalities of both Bloc Listener and Bloc Builder. It allows you to respond to state changes by executing functions and building widgets simultaneously. This is particularly useful for situations where you need to both update the UI and call functions in response to state changes.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                KotlinCode(
                    code = """
                    BlocConsumer<BlocA, BlocAState>(
                      listener: (context, state) {
                        // do stuff here based on BlocA's state
                      },
                      builder: (context, state){
                        // do stuff here based on BlocA's state
                      }
                    )
                    """.trimIndent()
                )
            }

            SpanText(
                text = "Bloc Selector",
                modifier = Modifier.fontSize(FontSize.Large)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Bloc Selector is a bloc builder that goes through a “filter” to return a bool based on the current state. The builder function uses the returned bool value to build the widget.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                KotlinCode(
                    code = $$"""
                    import 'package:flutter/material.dart';
                    import 'package:flutter_bloc/flutter_bloc.dart';

                    void main() {
                      runApp(const MyApp());
                    }

                    class MyApp extends StatelessWidget {
                      const MyApp({super.key});

                      @override
                      Widget build(BuildContext context) {
                        return BlocProvider(
                          create: (context) => AppCubit(),
                          child: MaterialApp(
                            title: 'Flutter Demo',
                            theme: ThemeData(
                              primarySwatch: Colors.blue,
                            ),
                            home: const MyHomePage(),
                          ),
                        );
                      }
                    }

                    class MyHomePage extends StatelessWidget {
                      const MyHomePage({super.key});

                      @override
                      Widget build(BuildContext context) {
                        return Scaffold(
                          appBar: AppBar(
                            title: Text(context.read<AppCubit>().state.title),
                          ),
                          body: Center(
                            child: BlocSelector<AppCubit, AppState, int>(
                              selector: (state) {
                                return state.value;
                              },
                              builder: (context, value) {
                                print("BlocSelector state.value rebuild");
                                return Column(
                                  mainAxisAlignment: MainAxisAlignment.center,
                                  children: <Widget>[
                                    const Text(
                                      'You have pushed the button this many times:',
                                    ),
                                    Text(
                                      '$value',
                                      style: Theme.of(context).textTheme.headlineMedium,
                                    ),
                                    ElevatedButton(
                                        onPressed: () {
                                          context.read<AppCubit>().changeTitle('Hello World');
                                        },
                                        child: const Text('Change title'))
                                  ],
                                );
                              },
                            ),
                          ),
                          floatingActionButton: FloatingActionButton(
                            onPressed: () {
                              context
                                  .read<AppCubit>()
                                  .changeCounter(context.read<AppCubit>().state.value + 1);
                            },
                            tooltip: 'Increment',
                            child: const Icon(Icons.add),
                          ),
                        );
                      }
                    }

                    class AppCubit extends Cubit<AppState> {
                      AppCubit() : super(AppState(0));

                      changeCounter(int value) {
                        emit(AppState(value));
                      }

                      changeTitle(String title) {
                        emit(AppState(state.value, title: title));
                      }
                    }

                    class AppState {
                      final int value;
                      final String title;
                      AppState(this.value, {this.title = 'Flutter Demo Home Page'});
                    }
                    """.trimIndent()
                )

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Flutter widget which provides a repository to its children via RepositoryProvider.of<>(context).",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It is used as a dependency injection (DI) widget so that a single instance of a repository can be provided to multiple widgets within a subtree. BlocProvider should be used to provide blocs whereas RepositoryProvider should only be used for repositories.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "BLocBuilder vs BlocSelector",
                modifier = Modifier.fontSize(FontSize.Large)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Rebuilds the entire widget tree whenever state changes.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Only rebuilds the Text widget when state.name changes.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                KotlinCode(
                    code = """
                        BlocSelector<FooBloc, FooState, String>( selector: (state) → state. name,
                            builder: (context, name) {
                                // Only rebuilds the Text widget when state.name changes.
                                return Text(name);
                            },
                        ),
                    """.trimIndent()
                )
            }

            SpanText(
                text = "MultiRepositoryProvider",
                modifier = Modifier.fontSize(FontSize.Large)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Merges multiple RepositoryProvider widgets into one widget tree. In this case, you’re providing repositories instead of Blocs to the list of providers.",
                        modifier = Modifier.padding(bottom = 0.3.em)
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "BlocConsumer",
                modifier = Modifier.fontSize(FontSize.Large)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "BlocConsumer is a mixture of BlocBuilder and BlocListener. It exposes a builder and listener to react to new states. BlocConsumer is analogous to nested BlocListener and BlocBuilder but reduces the amount of boilerplate needed. BlocConsumer should only be used when it is necessary to both rebuild UI and execute other reactions to state changes in the bloc.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            Ul {
                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "builder — It rebuilds the widget tree in response to the state changes, which means whenever you emit a new state it will rebuild the widgets so that you can use the value sent in the state that is emitted from the Bloc. So in this example, we have passed a text from the bloc in the UpdateTextStateand used it to so on the UI, This state is emitted whenever the “Tap me!!” button is tapped.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "listener — So whenever a state is emitted the listener also gets invoked, but unlike the builder, it doesn’t return any widget. It gets called once per state change, that’s why we generally use a listener that happens once whenever the state changes, like showing a snack bar, dialog, bottom sheet, or navigating to the next screen.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "buildWhen — This is an optional parameter that provides previous and current states and returns a boolean, so if we return true it will call the builder, or else it won’t if you don’t use this parameter the builder will be called for each state change.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "listenWhen: This is similar to buildWhen but used to control the Listener, if it returns true then the listener gets called.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = ".when: You must provide individual logic for each bloc state.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = ".maybeWhen: You must provide logic for some bloc states and logic for defaults.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "listenWhen and buildWhen",
                modifier = Modifier.fontSize(FontSize.Large)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "An optional listenWhen and buildWhen can be implemented for more granular control over when the listener and builder are called.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The listenWhen and buildWhen will be invoked on each bloc state change.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "They each take the previous state and current state and must return a bool which determines whether or not the builder and/or listener function will be invoked.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The previous state will be initialized to the state of the bloc when the BlocConsumer is initialized. listenWhen and buildWhen are optional and if they aren’t implemented, they will default to true.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "when vs whenOrNull",
                modifier = Modifier.fontSize(FontSize.Large)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    BlocConsumer<SplashCubit, SplashState>(
                    bloc: getIt<SplashCubit>()..isAuthenticatedUserCheck(),
                    listener: (_, state) {
                        ///when MUST BE ALL CUBIT STATE DEFINE AND whenOrNull NEED TO CUBIT STATE DEFINE
                        state.whenOrNull(
                        authenticate: () => context.go(RouterPath.home),
                        unAuthenticatedState: () => context.go(RouterPath.login));
                    },
                    builder: (_, state) => Scaffold(
                        body:
                            Center(child: Text(appName, style: context.headerLine6Context))))
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                     switch (state.runtimeType) { 
                        case UserDetailState.initial:
                            return Text('Clean archi');
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    @override
                    Widget build(BuildContext context) => Scaffold(
                    body: BlocBuilder<ReturnListCubit, ReturnListState>(
                    bloc: getIt<ReturnListCubit>()..returnListGetData(),
                        builder: (context, state) {
                            final status = (state.loading, state.returnList.isEmpty);

                            return switch (status) {
                                (true, _) => const PlatformLoadingIndicatorWidget(),
                                (_, true) => const ListViewEmptyWidget(),
                                (_, false) => ListView.builder(
                                    addAutomaticKeepAlives: false,
                                    addRepaintBoundaries: false,
                                        physics: const BouncingScrollPhysics(
                                        parent: AlwaysScrollableScrollPhysics()),
                                    itemCount: state.returnList.length,
                                    itemBuilder: (BuildContext context, int index) =>
                                    _returnItemView(context: context))
                            };
                        }
                    ));
                    """.trimIndent()
            )

            SpanText(
                text = "In short",
                modifier = Modifier.fontSize(FontSize.Large)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A Bloc must extend the base Bloc class from the core bloc package.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "EachBloc must define an initial state",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It must implement a function called mapEventToState. This function takes incoming event as the argument. It also returns a stream of new state as output.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "To access the current bloc state we can use currentState property",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A bloc has a dispatch method. Dispatch takes an event and triggers mapEventToState. Dispatch can be called in the presentation layer or from within a bloc",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "onTransition is called before a bloc state is updated",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "onError can override to know bloc exception.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "BlocObserver can be used to observe all blocs as well. onCreate, onEvent, onChange, onTransition, onError and onClose.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "Cubit",
                modifier = Modifier.fontSize(FontSize.Large)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Cubit is the subset of BLoC package.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Cubit is lightweight compared to bloc.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Cubit is a simplified version of BLoC that manages a single state object instead of multiple events and states as streams. To use Cubit, you define a Cubit that holds one state and provides methods to update it. Widgets rebuild when the Cubit emits a new state. Cubit reduces the boilerplate compared to BLoC while retaining the testability and architectural benefits.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Cubit does not have Event Streams and only has State Streams.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Events are replaced by functions so simply we need to call the function to get the States. So this reduces the extra boilerplate codes.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "While in Cubit in a single function call, we can emit multiple times the States.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Cubit is a special kind of Stream component based on some functions called from the UI. Functions that rebuild the UI by emitting different states on a Stream.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "A Cubit is a class that extends BlocBase and can be extended to manage any type of state.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Cubit requires an initial state which will be the state before emit has been called.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The current state of a cubit can be accessed via the state getter and the state of the cubit can be updated by calling emit with a new state.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "State changes in cubit begin with predefined function calls which can use the emit method to output new states. onChange is called on each state change and contains the current and next state.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "Transformers BLoC",
                modifier = Modifier.fontSize(FontSize.Large)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Concurrent — Process incoming event of bloc concurrently",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Sequential — Process incoming events one after another",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Droppable — Drops the incoming events if one event is being processed",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Restartable — Process the latest incoming event and stop the execution of the ongoing event.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "Internet connection checking using cubit",
                modifier = Modifier.fontSize(FontSize.Large)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    import 'dart:async';
                    import 'package:flutter_bloc/flutter_bloc.dart';
                    import 'package:connectivity_plus/connectivity_plus.dart';

                    enum InternetState { initial, lost, gained }

                    class InternetCubit extends Cubit<InternetState> {
                      final Connectivity _connectivity = Connectivity();
                      StreamSubscription? _connectivitySubscription;
                      InternetCubit() : super(InternetState.initial) {
                        _connectivitySubscription =
                            _connectivity.onConnectivityChanged.listen((result) {
                          if (result == ConnectivityResult.mobile ||
                              result == ConnectivityResult.wifi) {
                            emit(InternetState.gained);
                          } else {
                            emit(InternetState.lost);
                          }
                        });
                      }

                      @override
                      Future<void> close() {
                        _connectivitySubscription?.cancel();
                        return super.close();
                      }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    import 'package:flutter/material.dart';
                    import 'package:flutter_bloc/flutter_bloc.dart';

                    class HomePage extends StatelessWidget {
                      const HomePage({
                        super.key,
                      });

                      @override
                      Widget build(BuildContext context) {
                        return Scaffold(
                          body: Center(
                              child: BlocConsumer<InternetCubit, InternetState>(
                            listener: (context, state) {
                              if (state == InternetState.gained) {
                                ScaffoldMessenger.of(context).showSnackBar(
                                  const SnackBar(
                                    content: Text('Connected'),
                                    backgroundColor: Colors.green,
                                  ),
                                );
                              } else if (state == InternetState.lost) {
                                ScaffoldMessenger.of(context).showSnackBar(
                                  const SnackBar(
                                    content: Text('Not Connected'),
                                    backgroundColor: Colors.redAccent,
                                  ),
                                );
                              }
                            },
                            builder: (context, state) {
                              if (state == InternetState.gained) {
                                return const Text('Connected!');
                              } else if (state == InternetState.lost) {
                                return const Text('Not Connected!');
                              } else {
                                return const Text('Loading');
                              }
                            },
                          )),
                        );
                      }
                    }
                    """.trimIndent()
            )

            KotlinCode(
                code = """
                    import 'package:flutter/material.dart';
                    import 'package:flutter_bloc/flutter_bloc.dart';

                    void main() {
                      runApp(const MainApp());
                    }

                    class MainApp extends StatelessWidget {
                      const MainApp({super.key});

                      @override
                      Widget build(BuildContext context) {
                        return BlocProvider(
                          create: (context) => InternetCubit(),
                          child: const MaterialApp(
                            home: HomePage(),
                          ),
                        );
                      }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "BLoC Vs Cubit",
                modifier = Modifier.fontSize(FontSize.Large)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Bloc Takes Events and Gives State",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Bloc has Events and States as Streams",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Bloc has a limitation and that is without adding the Event we cannot emit any states. Events are added first and only the State is emitted.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "BLoC typically involves the use of multiple classes, such as the BLoC itself, events, and states. It requires setting up streams, sinks, and stream controllers to handle data flow and state changes.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "BLoC is designed to handle complex business logic and state management in an application. It provides a clear separation between the UI and the business logic layer, allowing for better testability and maintainability.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Cubit is the subset of BLoC package.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Cubit is lightweight compared to bloc.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Cubit does not have Event Streams and only has State Streams",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Events are replaced by functions so simply we need to call the function to get the States. So this reduces the extra boilerplate codes. While in Cubit in a single function call, we can emit multiple times the States.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Cubit simplifies the implementation by using a single class that extends the Cubit base class. It provides methods to emit states and manages the stream internally without exposing the underlying stream controller.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Cubit, on the other hand, is a more lightweight solution that is suitable for simpler applications or cases where the business logic is less complex. It is often used for managing local component state rather than global state.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "There is only a difference between the creation of State and emitting between Bloc and Cubit but there is no difference between using it.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "BLoC Vs GetX",
                modifier = Modifier.fontSize(FontSize.Large)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "BLoc: It is based on the principle of unidirectional data flow, which means that the state of the app is always updated in a predictable way. This makes it easier to debug and maintain large and complex apps.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "GetX: It uses a reactive programming approach, which can make it easier to develop dynamic and responsive user interfaces.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "BLoC: Bloc is a powerful framework that offers a lot of features such as Stream management, Event handling, and State management.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "GetX: It is a package that offers a range of features such as Dependency Injection (DI), Routing, State Management, and many more. GetX is a good choice for small, medium-sized and large applications because of its simplicity and ease of use.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "BLoC Vs Riverpod",
                modifier = Modifier.fontSize(FontSize.Large)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Bloc follows a unidirectional data flow with events and states. Riverpod offers a more direct and declarative approach to state management.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Bloc provides a structured and complex architecture. Riverpod offers a simpler and less boilerplate-heavy approach.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Bloc focuses primarily on individual widget state management. Riverpod streamlines global state sharing and management.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "BLoC leverages streams and promotes separation of business logic from UI. Riverpod uses a state notifier and focuses on reactivity.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "BLoC has a steeper learning curve with concepts like streams and sinks. Riverpod is more approachable for beginners.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "BLoC can involve creating many files — cubits, blocs, events, and states. Riverpod centralizes the state in fewer locations.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Riverpod makes accessing state and triggering reactions more direct. BLoC requires wrapping state interactions in events.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "BLoC is more established and has great community support. Riverpod is newer but rapidly gaining popularity.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                            .textAlign(TextAlign.Start)
                    )
                }
            }

            SpanText(
                text = "BLoC good practice",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    //init state api calling
                    
                    WidgetsBinding.instance.addPostFrameCallback((_) {
                        context.read<HomeBloc>().add(const GetNotes());
                    });     
                    
                    //constructor initialization
                    
                    @injectable
                    class TicketEventCubit extends Cubit<TicketEventState> {
                        final GetTicketEventUseCase _getTicketEventUseCase;

                        TicketEventCubit(this._getTicketEventUseCase)
                            : super(const TicketEventState (isLoading: false, eventList: []));
                    }
                            
                    //cubit part of add
                    
                    //cubit 
                    import 'package:freezed_annotation/freezed_annotation.dart';
                    
                    part 'ticket_event_state.dart';
                    part 'ticket_event_cubit.freezed.dart';   
                    
                    //state
                    part of 'ticket_event_cubit.dart';
       
                """.trimIndent()
            )

            SpanText(
                text = "BLoC Bottom Navigation",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    part of 'BottomNavi.dart';
                    enum BottomNavigationEvent { Home, Settings, Profile }
                    
                    import 'package:bloc/bloc.dart';
                    part 'BottomNaviEvent.dart';

                    class BottomNaviBloc extends Bloc<BottomNavigationEvent, int> {
                      BottomNaviBloc() : super(0) {
                        on<BottomNavigationEvent>((event, emit) {
                          switch (event) {
                            case BottomNavigationEvent.Home:
                              emit(0);
                              break;

                            case BottomNavigationEvent.Settings:
                              emit(1);
                              break;

                            case BottomNavigationEvent.Profile:
                              emit(2);
                              break;
                          }
                        });
                      }
                    }
                    
                    class MyHome extends StatelessWidget {
                        const MyHome({super.key});
                        Widget build(BuildContext context) {
                            final BottomNaviBloc _naviBloc = BlocProvider.of<BottomNaviBloc>(context);
                            return Scaffold(
                                appBar: AppBar(
                                        title: const Text("Bottom Navigation Bar"),
                            ),
                            body: BlocBuilder<BottomNaviBloc, int>(
                            builder: (context, currentIndex) {
                            switch (currentIndex) {
                                case 0:
                                return const Center(
                                        child: Text("Home"),
                                );
                                case 1:
                                return const Center(
                                        child: Text("Profile"),
                                );
                                case 2:
                                return const Center(
                                        child: Text("Settings"),
                                );
                                default:
                                return Container();
                            }
                        },
                            ),
                            bottomNavigationBar: BlocBuilder<BottomNaviBloc, int>(
                            builder: (context, currentIndex) {
                            return BottomNavigationBar(
                                currentIndex: currentIndex,
                                onTap: (index) {
                                _naviBloc.add(BottomNavigationEvent.values[index]);
                            },
                            items: const [
                            BottomNavigationBarItem(icon: Icon(Icons.home), label: "Home"),
                            BottomNavigationBarItem(
                                icon: Icon(Icons.person), label: "Profile"),
                            BottomNavigationBarItem(
                                icon: Icon(Icons.settings), label: "Settings"),
                            ],
                            );
                        },
                            ),
                            );
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "BLoC Multiple State",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    //STATE
                    abstract class AuthorState {}

                    class InitializeState extends AuthorState {}

                    class ErrorState extends AuthorState {
                      final String error;
                      ErrorState({required this.error});
                    }

                    class LoadingState extends AuthorState {}

                    class ReadAuthorState extends AuthorState {
                      final AuthorModel authorModel;
                      ReadAuthorState({required this.authorModel});
                    }

                    class AddAuthorLoading extends AuthorState {
                      bool isLoading;
                      AddAuthorLoading({required this.isLoading});
                    }

                    class UpdateAuthorLoading extends AuthorState {
                      bool isLoading;
                      UpdateAuthorLoading({required this.isLoading});
                    }

                    class DeleteAuthorLoading extends AuthorState {
                      bool isLoading;
                      DeleteAuthorLoading({required this.isLoading});
                    }

                    //EVENT
                    import 'package:flutter/material.dart';
                    abstract class AuthorEvent {}

                    class ReadAuthorEvent extends AuthorEvent {}

                    class AddAuthorEvent extends AuthorEvent {
                      final String name;
                      final BuildContext context;
                      AddAuthorEvent({required this.name, required this.context});
                    }

                    class UpdateAuthorEvent extends AuthorEvent {
                      final String id;
                      final String name;
                      final BuildContext context;
                      UpdateAuthorEvent(this.context, {required this.id, required this.name});
                    }

                    class DeleteAuthorEvent extends AuthorEvent {
                      final String id;
                      DeleteAuthorEvent({required this.id});
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "BLoC open bottom sheet",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                      static Future<T?> showBottomSheet<T>(BuildContext context, {
                        required WidgetBuilder builder,
                        RouteSettings? routeSettings,
                        bool isFullScreen = false
                      }) async {
                        if(ModalRoute.of(context)!.isCurrent){
                          return await showModalBottomSheet(
                            context: context,
                            builder: builder,
                            backgroundColor: Colors.transparent,
                            routeSettings: routeSettings,
                            isScrollControlled: isFullScreen
                          );
                        }
                        return null;
                      }
                      
                      DialogUtil.showBottomSheet(
                        context,
                        isFullScreen: true,
                        routeSettings: RouteSettings(arguments: context.read<NotificationBloc>()),
                        builder: (context) => _buildFilterWidget(context)
                      );
                      
                        Widget _buildFilterWidget(BuildContext context){
                          NotificationBloc notificationBloc = ModalRoute.of(context)!.settings.arguments as NotificationBloc;
                          return DraggableScrollableSheet(
                            initialChildSize: 1.0,
                            maxChildSize: 1.0,
                            minChildSize: 0.5,
                            builder: (context, controller){
                              return Container();
                            },
                          );
                        }
                    """.trimIndent()
            )

            SpanText(
                text = "Cubit Favourite / UnFavourite, Bookmark",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            KotlinCode(
                code = """
                    Future<void> favouriteEvent({String? id, bool? isFavourite}) async {
                        final favouriteList = state.eventList!.map((EventsEntity eventsEntity) {
                            if (eventsEntity.id == id) {
                                return eventsEntity.copyWith(isFavourite: !isFavourite!);
                            } else {
                                return eventsEntity;
                            }
                        }).toList();

                        //final filterList = eventList!.where((EventsEntity t) => t.id == id).toList();

                        emit(state.copyWith(eventList: favouriteList));
                    }

                    """.trimIndent()
            )

            KotlinCode(
                code = """
                     //Counter Animation
                     //https://github.com/zainulabdn/fashion-shop-ui
                     
                     AnimatedSwitcher(
                        duration: const Duration(milliseconds: 300),
                        transitionBuilder:(child,animation) {
                            // we are adding FadeTransition effect to our counter text
                            // here we are using SlideTransition to animate our counter in much cooler way
                            // and we are creating the position to animate our text in specific direction
                            
                            final position=Tween<Offset>(
                                begin: const Offset(0, 1), 
                                end: Offset.zero);
                                    return FadeTransition(
                                        opacity: animation,
                                        child: SlideTransition(
                                            position: position.animate(animation),
                                            child: child));
                        },
                        child: Text(
                            provider.count.toString(),
                            key:UniqueKey(),
                            style: Theme.of(context).textTheme.headlineSmall?.copyWith(fontWeight: FontWeight.bold)))
                    """.trimIndent()
            )


            Link(
                path = "https://github.com/fluttertutorialin/todo_bloc_freezed-main",
                text = "TODO App BLoC with Freezed",
                modifier = Modifier
                    .margin(right = 4.px)
            )

            Link(
                path = "https://github.com/fluttertutorialin/weather_flutter.git",
                text = "Weather App using Clean Architecture",
                modifier = Modifier
                    .margin(right = 4.px)
            )
        }
    }
}